/**
 * Acta Documentum — Public-share API helpers (no auth required).
 * Used by `pages/PublicShare.jsx`.
 */
import { api, API_BASE } from "../lib/api";

export const fetchInfo = (token) =>
  api.get(`/public/shares/${token}/info`).then((r) => r.data);

export const signInstallationReport = (token, file, customerName) => {
  const form = new FormData();
  form.append("file", file);
  form.append("customer_name", customerName);
  form.append("consent", "true");
  return api.post(`/public/shares/${encodeURIComponent(token)}/installation-signature`, form)
    .then((response) => response.data);
};

export const fetchShare = (token) =>
  api.get(`/public/shares/${token}`).then((r) => r.data);

export const fileUrl = (token, docId, download = false) =>
  `${API_BASE}/public/shares/${token}/documents/${docId}/file${download ? "?download=true" : ""}`;

export const tickReadingTime = (token, documentId, seconds) =>
  api.post(`/public/shares/${token}/reading-time`, { document_id: documentId, seconds });

export const requestReopen = (token, payload) =>
  api.post(`/public/shares/${token}/reopen-request`, payload).then((r) => r.data);

export const publicBranding = (tenantId) =>
  api.get(`/public/tenant-branding/${tenantId}`).then((r) => r.data);

// Réponse rapide depuis la page publique de partage.
export const sendQuickFeedback = (token, payload) =>
  api.post(`/public/shares/${token}/quick-feedback`, payload).then((r) => r.data);

// Preview sécurisé des documents statiques.
// Ne renvoie jamais l’URL du fichier original.
export const fetchDocumentPreview = (token, documentId) =>
  api.get(`/public/shares/${token}/documents/${documentId}/preview`).then((r) => r.data);

// URL d’une page image JPEG générée côté backend.
export const documentPreviewPageUrl = (token, documentId, pageNumber) =>
  `${API_BASE}/public/shares/${token}/documents/${documentId}/preview/pages/${pageNumber}`;

export const fetchMessages = (token) =>
  api.get(`/public/shares/${token}/messages`).then((r) => r.data);

export const sendMessage = (token, payload) =>
  api.post(`/public/shares/${token}/message`, payload).then((r) => r.data);

export const createAppointment = (token, payload) =>
  api.post(`/public/shares/${token}/appointments`, payload).then((r) => r.data);

export const updateAppointment = (token, appointmentId, payload) =>
  api.put(`/public/shares/${token}/appointments/${appointmentId}`, payload).then((r) => r.data);

// Exchange public : messages + rendez-vous.
export const listExchangeMessages = (token) =>
  api.get(`/public/shares/${token}/exchange/messages`).then((r) => r.data);

export const sendExchangeMessage = (token, payload) =>
  api.post(`/public/shares/${token}/exchange/messages`, payload).then((r) => r.data);

export const listExchangeMeetings = (token) =>
  api.get(`/public/shares/${token}/exchange/meetings`).then((r) => r.data);

export const proposeExchangeMeetings = (token, payload) =>
  api.post(`/public/shares/${token}/exchange/meetings`, payload).then((r) => r.data);

// ACTA_PUBLIC_EXCHANGE_READ_AND_RESPONSE_API_V2
export const markExchangeMessagesRead = (token) =>
  api
    .post(`/public/shares/${token}/exchange/messages/read`)
    .then((r) => r.data);

export const markExchangeMeetingsRead = (token) =>
  api
    .post(`/public/shares/${token}/exchange/meetings/read`)
    .then((r) => r.data);

export const respondExchangeMeeting = (
  token,
  meetingId,
  payload
) =>
  api
    .post(
      `/public/shares/${token}/exchange/meetings/${meetingId}/respond`,
      payload
    )
    .then((r) => r.data);
